module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-taiguo.12341d74.jpg";